



























import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Device from "@/store/entities/device";
@Component
export default class AddDevice extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  device: Device = new Device();
  offices: Array<any> = [];

  init(list: Array<any>) {
    this.offices = list;
  }

  save() {
    (this.$refs.deviceForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "device/create",
          data: this.device,
        });
        (this.$refs.deviceForm as any).resetFields();
        this.$emit("add-success");
        this.$emit("input", false);
      }
    });
  }

  cancel() {
    (this.$refs.deviceForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", false);
    }
  }

  deviceRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur",
      },
    ]
  };
}
